import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, FloatingLabel, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../../ActivityLog';
import CancelDialog from '../../CancelDialog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Master_individual_profile from '../../master/Master_individual_profile';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import Tran_data_unlock_request from '../../Tran_data_unlock_request';


const Inter_branch_entry = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [locationValue, setLocationValue] = useState(null);
    const [locationCode, setLocationCode] = useState('');
    const [location, setLocation] = useState('');
    const [toLocationValue, setToLocationValue] = useState(null);
    const [toLocationCode, setToLocationCode] = useState('');
    const [toLocation, setToLocation] = useState('');
    const [branchGroup, setBranchGroup] = useState('');
    const [branchAccount, setBranchAccount] = useState('');
    const [branchAccountName, setBranchAccountName] = useState('');
    const [noteType, setNoteType] = useState('D');
    const [radioType, setRadioType] = useState("N");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [srnoFrom, setSrnoFrom] = useState("");
    const [srnoTo, setSrnoTo] = useState("");
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const [filterDate, setFilterDate] = useState(new Date());
    const currentDate = new Date();
    const [scrMode, setScrMode] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [ledgerValue, setLedgerValue] = useState('');
    const [grpCode, setGrpCode] = useState('0');
    const [accCode, setAccCode] = useState('0');
    const [accountType, setAccountType] = useState('');
    const [accountName, setAccountName] = useState('');
    const [amount, setAmount] = useState('');
    const [knockoffValue, setKnockoffValue] = useState(null);
    const [knockoffSrno, setKnockoffSrno] = useState('');
    const [knockoffType, setKnockoffType] = useState('');
    const [knockoffAmt, setKnockoffAmt] = useState('');
    const [knockoffPending, setKnockoffPending] = useState('');
    const [knockoffLineNo, setKnockoffLineNo] = useState('');
    const [knockoffFlag, setKnockoffFlag] = useState('');
    const [knockoffLedger, setKnockoffLedger] = useState('');
    const [knockoffData, setKnockoffData] = useState([]);
    const [flag, setFlag] = useState('D');
    const [limit, setLimit] = useState('100');
    const [srch, setSrch] = useState('');
    const [show, setShow] = useState(false);
    const [counter, setCounter] = useState('0');
    const [bookList, setBookList] = useState([]);
    // const [showHeaderList, setShowHeaderList] = useState(false);
    const [headerList, setHeaderList] = useState([]);
    const [srNo, setSrNo] = useState("0");
    const [randomString, setRandomString] = useState("0");
    // const [showList, setShowList] = useState(false);
    const [chequeNum, setChequeNum] = useState("");
    const [bankName, setBankName] = useState("");
    const [chequeDate, setChequeDate] = useState(new Date());
    const [totalDebit, setTotalDebit] = useState("0");
    const [totalCredit, setTotalCredit] = useState("0");
    const [totalDifference, setTotalDifference] = useState("0");
    const [isChecked, setChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [acRemark, setAcRemark] = useState("");
    const [code, setCode] = useState(0);
    const [addCount, setAddCount] = useState("0");
    const [narration, setNarration] = useState("");
    const [viewSrno, setViewSrno] = useState("");
    const [viewDate, setViewDate] = useState("");
    const [transferCheque, setTransferCheque] = useState('T');
    const [chequeValue, setChequeValue] = useState("");
    const [chequeValueNum, setChequeValueNum] = useState("");
    const [chequeLine, setChequeLine] = useState("");
    const [chequeSrno, setChequeSrno] = useState("");
    const [chequeLocation, setChequeLocation] = useState("");
    const [chequeStatus, setChequeStatus] = useState(null);
    const [nIndividual, setNIndividual] = useState(null);
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [nCorporate, setNCorporate] = useState(null);
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [faStateValue, setFAStateValue] = useState(0);
    const [faStateName, setFAStateName] = useState("");
    const [editDate, setEditDate] = useState('');
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [activityLogObject, setActivityLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [viewTypeCD, setViewTypeCD] = useState("");

    const [picklistIndividualCode, setPicklistIndividualCode] = useState("");
    const [picklistIndividualName, setPicklistIndividualName] = useState("");
    const [tempLineNo, setTempLineNo] = useState(1);

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setLocationValue(response);
                response != null && handleChange(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'INTER_BRANCH_ENTRY'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserCancelBillRight(resp);
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChange = (value) => {
        setLocationValue(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setIsBranchDisableForAddNew(loc[9]);
    }

    const handleLocationChange = (value) => {
        setToLocationValue(value);
        const loc = value.id.split('^');
        setToLocationCode(loc[1]);
        setToLocation(loc[2]);
        setBranchGroup(loc[6]);
        setBranchAccount(loc[7]);
        setBranchAccountName(loc[8]);
        //sessionStorage.activeBranch = location[1];
    }

    const handleNoteType = (e) => {
        let value = e.target.value;
        setNoteType(value);
        if (value == 'C') {
            setRadioType('S');
        } else {
            setRadioType('N');
        }
    }

    const handleAddNew = () => {
        var msg = [], i = 0;
        var d = Common.dateYMD(filterDate);
        var today = Common.dateYMD(new Date());
        if (locationValue === null || toLocationValue === null || !filterDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (locationValue === null ? " From Branch." : '');
            msg[i++] = (toLocationValue === null ? " To Branch." : '');
            msg[i++] = (!filterDate ? " Select date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (locationCode === toLocationCode) {
            setMsgText("From Branch and To Branch should not be same!.");
            setMsgBox(true);
        } else if (d > finEndDate || d < finStartDate) {
            setMsgText(Common.getMessage("MSG0010"));
            setMsgBox(true);
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } 
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (d == today) {
                addNewFormResetFields();
                // setViewTypeCD()
            } else {
                const obj = {
                    billdate: d,
                    location: locationCode,
                    type: 'IB'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = () => {
        setScrMode('A');
        setRandomString(Common.getRandomString(15));
        setAmount('');
        setBookList([]);
        setSrNo(0);
        setViewSrno(0);
        setNarration('');
        setKnockoffLedger(null);
        setTotalCredit(0);
        setTempLineNo(1);
        setKnockoffValue(null);
        setTotalDebit(0);
    }

    const handleCancel = () => {
        setMsgTextYN("Do you really want to exit");
        setMsgBoxYN(true);
    }

    const cancelData = () => {
        setScrMode('');
        // setShowHeaderList(true);
        handleShowList();
        setChecked(false);
        setMsgBoxYN(false);
        setAmount("");
        setLedgerValue(null);
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        const account = value.id.split('^');
        setGrpCode(account[1]);
        setAccCode(account[2]);
        setAccountType(account[4]);
        setAccountName(account[3]);
    }

    const handleKnockoffValue = (value) => {
        setKnockoffValue(value);
        const knockoff = value.id.split('^');
        setKnockoffSrno(knockoff[3]);
        setKnockoffType(knockoff[2]);
        setKnockoffAmt(knockoff[6]);
        setKnockoffLineNo(knockoff[4]);
        setKnockoffPending(knockoff[8]);
        setKnockoffFlag(knockoff[9]);
        setKnockoffLedger(knockoff[10]);
        setPicklistIndividualCode(knockoff[11]);
        setPicklistIndividualName(knockoff[12]);
    }

    const handleKnockoffSelective = () => {
        var msg = [], i = 0;
        if (ledgerValue == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue == null ? "Please select account." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let accountType;
            if (ledgerValue != null) {
                accountType = ledgerValue.id.split('^')[4];
            }
            const obj = {
                data: `${flag}^${grpCode}^${accCode}^${Common.dateYMD(filterDate)}^${randomString}`,
                limit: limit,
                srch: srch,
                accountType: accountType,
                location: locationCode
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'getknockoff', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setKnockoffData(resp);
            });
            setShow(true);
        }
    }

    const updateKnockoffFields = (index, e, name) => {
        let tempArr = knockoffData.map((item, i) => {
            if (index === i) {
                if (name === "tfd_amount") {
                    return { ...item, [name]: e.target.value };
                } else {
                    if (e.target.checked) {
                        return { ...item, [name]: '1', 'tfd_random_for_1lineno': Common.getRandomString(10) };
                    } else {

                        return { ...item, [name]: '0', 'tfd_random_for_1lineno': "" };
                    }
                }
            } else {
                return item;
            }
        });
        setKnockoffData(tempArr);
    }

    const selectiveKnockoffCHeckHandler = (e) => {
        let tempArr = [];
        if (e.target.checked) {
            tempArr = knockoffData.map((item) => {
                return { ...item, "ischecked": '1', 'tfd_random_for_1lineno': Common.getRandomString(10) };
            });
        } else {
            tempArr = knockoffData.map((item) => {
                return { ...item, "ischecked": '0', 'tfd_random_for_1lineno': Common.getRandomString(10) };
            });
        }
        setKnockoffData(tempArr);
    }


    const handleClose = () => {
        setShow(false);
    }

    const handleAddKnockoff = () => {
        var isOk = false;
        for (let i = 0; i < knockoffData.length; i++) {
            if (knockoffData[i].ischecked == "1") {
                isOk = true;
                // if (knockoffData[i].tfd_account_type === "WALKIN" && nIndividual === null) {
                //     isOk = false;
                //     setMsgBox(true);
                //     setMsgText("Individual is mandatory when WALKIN is picked.");
                //     setShow(false);
                //     return;
                // }
                if ((knockoffData[i].tfd_amount) * 1 > (knockoffData[i].tfd_pending_amount) * 1) {
                    setMsgBox(true);
                    setMsgText("Entered amount can't be greater then pending amount. [Pending: " + knockoffData[i].tfd_pending_amount + ", Entered: " + knockoffData[i].tfd_amount + "].");
                    setShow(false);
                    return;
                }
            }
        }
        if (isOk) {
            const obj = {
                knockoffData: knockoffData,
                randomString: randomString,
                flag: 'C',
                trantype: "IB"
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'addknockoffSelective', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setShow(false);
                // setShowKnockoff(true);
                setCounter(counter + 1);
                // setShowList(true);
                setLedgerValue(null);
                setNIndividual(null);
                calculateTotal(resp);
                setKnockoffValue(null);
                setKnockoffType("");
                setKnockoffSrno("");
                setKnockoffAmt("");
                setAmount('');
                setAddCount(addCount + 1);
                for (let i = 0; i < knockoffData.length; i++) {
                    if (knockoffData[i].ischecked == "1") {
                        for (let k = 0; k < resp.length; k++) {
                            if (knockoffData[i].tfd_random_for_1lineno === resp[k].tfd_random_for_1lineno) {
                                knockoffData[i].tfd_transfer_type = "";
                                knockoffData[i].tfd_cheque_status = "";
                                knockoffData[i].cheque_date = "";
                                knockoffData[i].tfd_cheque_bank_name = "";
                                knockoffData[i].tfd_cheque_no = "";
                                knockoffData[i].tfd_account_type = "";
                                knockoffData[i].chequeValueNum = "";
                                knockoffData[i].tfd_flag = noteType === "D" ? "C" : "D";
                                knockoffData[i].tfd_srno = resp[0].tfd_srno;
                                knockoffData[i].tfd_line_no = resp[0].tfd_line_no;
                                knockoffData[i].tfd_knockoff_amount = resp[0].tfd_amount;
                                knockoffData[i].tfd_reftype = "";
                                knockoffData[i].mvli_ledger_name = resp[0].mvli_ledger_name;

                                knockoffData[i].tfd_1srno = resp[k].tfd_1srno;
                                knockoffData[i].tfd_1line_no = resp[k].tfd_1line_no;
                                knockoffData[i].tfd_1type = resp[k].tfd_1type;
                                // if (knockoffData[i].ischecked == '0') continue;
                                setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                                break;
                            }
                        }
                    }
                }
                // for (let i = 0; i < knockoffData.length; i++) {
                //     knockoffData[i].tfd_transfer_type = "";
                //     knockoffData[i].tfd_cheque_status = "";
                //     knockoffData[i].cheque_date = "";
                //     knockoffData[i].tfd_cheque_bank_name = "";
                //     knockoffData[i].tfd_cheque_no = "";
                //     knockoffData[i].tfd_account_type = "";
                //     knockoffData[i].chequeValueNum = "";
                //     knockoffData[i].tfd_flag = noteType === "D" ? "C" : "D";
                //     knockoffData[i].tfd_srno = resp[0].tfd_srno;
                //     knockoffData[i].tfd_line_no = resp[0].tfd_line_no;
                //     knockoffData[i].tfd_knockoff_amount = resp[0].tfd_amount;
                //     knockoffData[i].tfd_reftype = "";
                //     knockoffData[i].mvli_ledger_name = resp[0].mvli_ledger_name;
                //     if (knockoffData[i].ischecked == '0') continue;
                //     setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                // }
            });
        } else {
            setShow(false);
            setMsgText(" No value selected for knocking off ");
            setMsgBox(true);
        }
    }

    const handleAddKnockoffMultiple = () => {
        var isOk = false;
        for (let i = 0; i < knockoffData.length; i++) {
            if (knockoffData[i].ischecked == "1") {
                isOk = true;
                // if (knockoffData[i].tfd_account_type === "WALKIN" && nIndividual === null) {
                //     isOk = false;
                //     setMsgBox(true);
                //     setMsgText("Individual is mandatory when WALKIN is picked.");
                //     setShow(false);
                //     return;
                // }
                if ((knockoffData[i].tfd_amount) * 1 > (knockoffData[i].tfd_pending_amount) * 1) {
                    setMsgBox(true);
                    setMsgText("Entered amount can't be greater then pending amount. [Pending: " + knockoffData[i].tfd_pending_amount + ", Entered: " + knockoffData[i].tfd_amount + "].");
                    setShow(false);
                    return;
                }
            }
        }
        if (isOk) {
            const obj = {
                knockoffData: knockoffData,
                randomString: randomString,
                flag: 'C',
                trantype: "IB"
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'addknockoffSelective', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                // setShow(false);
                // setShowKnockoff(true);
                setCounter(counter + 1);
                // setShowList(true);
                // setLedgerValue(null);
                // setNIndividual(null);
                calculateTotal(resp);
                setKnockoffValue(null);
                setKnockoffType("");
                setKnockoffSrno("");
                setKnockoffAmt("");
                setAmount('');
                setAddCount(addCount + 1);
                for (let i = 0; i < knockoffData.length; i++) {
                    if (knockoffData[i].ischecked == "1") {
                        for (let k = 0; k < resp.length; k++) {
                            if (knockoffData[i].tfd_random_for_1lineno === resp[k].tfd_random_for_1lineno) {
                                knockoffData[i].tfd_transfer_type = "";
                                knockoffData[i].tfd_cheque_status = "";
                                knockoffData[i].cheque_date = "";
                                knockoffData[i].tfd_cheque_bank_name = "";
                                knockoffData[i].tfd_cheque_no = "";
                                knockoffData[i].tfd_account_type = "";
                                knockoffData[i].chequeValueNum = "";
                                knockoffData[i].tfd_flag = noteType === "D" ? "C" : "D";
                                knockoffData[i].tfd_srno = resp[0].tfd_srno;
                                knockoffData[i].tfd_line_no = resp[0].tfd_line_no;
                                knockoffData[i].tfd_knockoff_amount = resp[0].tfd_amount;
                                knockoffData[i].tfd_reftype = "";
                                knockoffData[i].mvli_ledger_name = resp[0].mvli_ledger_name;

                                knockoffData[i].tfd_1srno = resp[k].tfd_1srno;
                                knockoffData[i].tfd_1line_no = resp[k].tfd_1line_no;
                                knockoffData[i].tfd_1type = resp[k].tfd_1type;
                                // if (knockoffData[i].ischecked == '0') continue;
                                setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                                break;
                            }
                        }
                    }
                }
                handleKnockoffSelective();
                // for (let i = 0; i < knockoffData.length; i++) {
                //     knockoffData[i].tfd_transfer_type = "";
                //     knockoffData[i].tfd_cheque_status = "";
                //     knockoffData[i].cheque_date = "";
                //     knockoffData[i].tfd_cheque_bank_name = "";
                //     knockoffData[i].tfd_cheque_no = "";
                //     knockoffData[i].tfd_account_type = "";
                //     knockoffData[i].chequeValueNum = "";
                //     knockoffData[i].tfd_flag = noteType === "D" ? "C" : "D";
                //     knockoffData[i].tfd_srno = resp[0].tfd_srno;
                //     knockoffData[i].tfd_line_no = resp[0].tfd_line_no;
                //     knockoffData[i].tfd_knockoff_amount = resp[0].tfd_amount;
                //     knockoffData[i].tfd_reftype = "";
                //     knockoffData[i].mvli_ledger_name = resp[0].mvli_ledger_name;
                //     if (knockoffData[i].ischecked == '0') continue;
                //     setBookList(Common.arrayAddItem(bookList, knockoffData[i]));
                // }
            });
        } else {
            setShow(false);
            setMsgText(" No value selected for knocking off ");
            setMsgBox(true);
        }

    }


    const handleAdd = () => {
        var msg = [], i = 0, chequeNumLocal = '';
        setChequeNum(chequeNum.trim());
        chequeNumLocal = chequeNum.trim();

        $(".loader").show();
        if (ledgerValue == null || amount === '' ||
            (accountType == 'CHEQUE' && chequeDate == null) || (accountType == 'CHEQUE' && chequeNumLocal == '') || (accountType == 'CHEQUE' && bankName == '') ||
            (accountType == 'BANK' && noteType == 'C' && transferCheque == 'T' && chequeNumLocal == '') || (accountType == 'BANK' && noteType == 'C' && transferCheque == 'C' && chequeNumLocal == '') ||
            (noteType == 'D' && transferCheque == 'T' && accountType == 'BANK' && chequeNumLocal == '') || (noteType == 'D' && transferCheque == 'C' && accountType == 'BANK' && chequeNumLocal == '') ||
            (noteType == 'D' && transferCheque == 'C' && accountType == 'BANK' && bankName == '')
            || (accountType == 'CHEQUE') || (accountType === "WALKIN" && nIndividual === null && knockoffValue === null)
            || ((accountType == 'BANK') && (bookList.some(item => item.tfd_group === grpCode && item.tfd_account === accCode && item.tfd_cheque_no === chequeNumLocal)))) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ledgerValue == null ? "Please select account." : '');
            msg[i++] = (amount === '' ? "Please fill amount." : '');
            msg[i++] = ((accountType == 'CHEQUE') ? 'This Group is not allowed in IB' : '');
            //msg[i++] = ((accountType == 'CHEQUE' && chequeNum == '') ? 'Fill Cheque number' : '');
            //msg[i++] = ((accountType == 'CHEQUE' && bankName == '') ? 'Fill Bank Name' : '');
            //msg[i++] = ((accountType == 'CHEQUE' && chequeDate == null) ? "Please select date." : '');
            msg[i++] = ((accountType == 'BANK' && noteType == 'C' && transferCheque == 'T' && chequeNumLocal == '') ? 'Fill Reference Number' : '');
            msg[i++] = ((accountType == 'BANK' && noteType == 'C' && transferCheque == 'C' && chequeNumLocal == '') ? 'Fill Cheque Number' : '');
            msg[i++] = ((accountType == 'BANK' && noteType == 'D' && transferCheque == 'T' && chequeNumLocal == '') ? 'Fill Reference Number' : '');
            msg[i++] = ((accountType == 'BANK' && noteType == 'D' && transferCheque == 'C' && chequeNumLocal == '') ? 'Fill Cheque Number' : '');
            msg[i++] = ((noteType == 'D' && transferCheque == 'C' && accountType == 'BANK' && bankName == '') ? 'Fill Bank Name' : '');
            msg[i++] = ((accountType === "WALKIN" && nIndividual === null && knockoffValue === null) ? "Individual is mandatory when walkin is picked." : "");
            msg[i++] = (((accountType == 'BANK') && (bookList.some(item => item.tfd_group === grpCode && item.tfd_account === accCode && item.tfd_cheque_no === chequeNumLocal))) ? "Reference number already exist." : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        else {
            setAddCount(addCount + 1);
            let individual_name = '';
            let individual_id = 0;
            if (knockoffValue !== null) {
                individual_name = picklistIndividualName;
                individual_id = picklistIndividualCode;
            } else {
                if (nIndividual != null) {
                    let individual = nIndividual.id.split('^');
                    individual_name = individual[2];
                    individual_id = individual[1];
                }
            }
            let chqDate = "";
            let transferType = "";
            if (accountType == 'CHEQUE') {
                chqDate = Common.dateYMD(chequeDate);
            } else if (accountType == 'BANK') {
                transferType = transferCheque;
                chqDate = chequeDate;
            }
            let tcbb_srno = 0;
            let tcbb_line_no = 0;
            let tcbb_location = 0;
            let tcbb_from = 0;
            let tcbb_type = '';
            if (accountType === "BANK" && transferCheque === "C") {
                const ch = chequeValue.id.split("^");
                tcbb_srno = ch[1];
                tcbb_line_no = ch[2];
                tcbb_location = ch[3];
                tcbb_from = ch[4];
                tcbb_type = ch[5];
            }

            let obj;
            if (knockoffValue == null) {
                obj = {
                    uniquekey: Common.getRandomString(15),
                    tfd_date: Common.dateYMD(filterDate),
                    tfd_type: 'IB',
                    tfd_flag: 'C',
                    tfd_amount: amount,
                    tfd_location: locationCode,
                    tfd_group: grpCode,
                    tfd_account: accCode,
                    tfd_account_type: accountType,
                    mvli_ledger_name: accountName,
                    srno: srNo,
                    tfd_srno: srNo,
                    tfd_individual: individual_name,
                    tfd_individual_code: individual_id,
                    tfd_cheque_no: chequeNumLocal,
                    tfd_cheque_bank_name: accountType == 'BANK' ? accountName : bankName,
                    cheque_date: (chqDate === null || chqDate === "" ? "" : Common.dateYMD(chqDate)),//
                    tfd_cheque_status: chequeStatus,
                    chequeValueNum: chequeValueNum,
                    tfd_transfer_type: transferType,
                    tfd_knockoff_srno: 'null',
                    tfd_knockoff_type: "",
                    tfd_knockoff_lineno: 'null',
                    tfd_reftype: "",
                    delny: 'Y',

                    tcbb_srno: tcbb_srno,
                    tcbb_line_no: tcbb_line_no,
                    tcbb_location: tcbb_location,
                    tcbb_from: tcbb_from,
                    tcbb_type: tcbb_type
                }
            } else {
                obj = {
                    tfd_line_no: '',
                    tfd_location: locationCode,
                    tfd_type: 'IB',
                    tfd_srno: '',
                    tfd_knockoff_type: knockoffType,
                    tfd_knockoff_srno: knockoffSrno,
                    tfd_knockoff_lineno: knockoffLineNo,
                    tfd_group: grpCode,
                    tfd_account: accCode,
                    tfd_amount: amount,
                    tfd_flag: 'C',
                    // tfd_flag: knockoffFlag,
                    tfd_date: Common.dateYMD(filterDate),
                    mvli_ledger_name: knockoffLedger,
                    randomString: randomString,
                    delny: 'Y',
                    tfd_transfer_type: "",
                    tfd_cheque_status: "",
                    cheque_date: "",
                    tfd_cheque_bank_name: "",
                    tfd_cheque_no: "",
                    tfd_individual_code: "",
                    tfd_account_type: "",
                    chequeValueNum: "",
                    tfd_reftype: "",

                    tcbb_srno: tcbb_srno,
                    tcbb_line_no: tcbb_line_no,
                    tcbb_location: tcbb_location,
                    tcbb_from: tcbb_from,
                    tfd_individual: individual_name,
                    tfd_individual_code: individual_id,
                    uniquekey: Common.getRandomString(15),

                    tfd_1type: "IB",
                    tfd_1line_no: tempLineNo,
                    tfd_1srno: 1,
                }
                Common.callApi(Common.apiIBEntry, [sid, 'addknockoffSingle', JSON.stringify(obj)], (result) => {
                    let resp = JSON.parse(result);
                    obj.tfd_line_no = resp[0].tfd_line_no;
                    obj.tfd_srno = resp[0].tfd_srno;
                });
                setTempLineNo(tempLineNo + 1);
            }
            setBookList(Common.arrayAddItem(bookList, obj));
            setCounter(counter + 1);
            // setShowList(true);
            setAmount("");
            setNoteType("D");
            setLedgerValue(null);
            setBankName("");
            setChequeNum("");
            setBankName("");
            setNIndividual(null);
            setChequeStatus(null);
            calculateTotal(bookList);
            setChequeDate(new Date());
            setAccountType("");
            setTransferCheque('T');
            setKnockoffValue(null);
            setKnockoffType("");
            setKnockoffSrno("");
            setKnockoffAmt("");
            $(".loader").hide();
        }
    }
    //console.log(bookList);
    const handleSave = () => {
        if (addCount == '0' && scrMode == 'A') {
            setMsgText("You can't save without adding data");
            setMsgBox(true);
        } else if (scrMode === 'E' && acRemark === '') {
            setShowModal(true);
        } else if (narration === "") {
            setMsgText("Please fill Narration.");
            setMsgBox(true);
        } else if ((narration.trim()).length < 45) {
            setMsgText("Narration length should be a minimum of 45 characters.");
            setMsgBox(true);
        } else {
            const obj = {
                remark: acRemark,
                activitytype: code == 1 ? 'MODIFY' : 'CREATE',
                subtranno: code,
                trannumber: srNo,
                trantype: 'IB',
                trancategory: 'T',
                branch: locationCode,

                location: locationCode,
                toLocation: toLocationCode,
                flag: noteType,
                date: (radioType == 'N' ? Common.dateYMD(filterDate) : viewDate?.split('/').reverse().join('-')),
                type: 'IB',
                narration: narration,
                bookList: bookList,
                radioType: radioType,
                scrMode: scrMode,
                srNo: srNo,
                totalCredit: totalCredit,
                totalDebit: totalDebit,
                group: grpCode,
                account: accCode,
                chequeSrno: chequeSrno,
                chequeLine: chequeLine,
                chequeLocation: chequeLocation,
                chequeNum: chequeNum,
                randomString: randomString,
                knockoffValue: knockoffValue
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'saveIBEntry', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setScrMode('Q');
                calculateTotal(resp.resarray);
                if (radioType == 'N') {
                    setBookList(resp.resarray);
                    setSrNo(resp.srno);
                } else {
                    setBookList(resp.resarray);
                }
                setEditDate(radioType === "N" ? Common.dateYMD1(filterDate) : viewDate);
                setViewDate(Common.dateDMYStr(resp.resarray[0].tfd_date));
                setChecked(false);
                setAddCount(0);
                setAcRemark('');
                setViewSrno(resp.srno);
                setAmount('');
                // setNarration('');
                // setTotalCredit(0)
            });
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: srNo,
                    type: 'IB',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'INTER_BRANCH_ENTRY'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                });
            }
        }
    }

    const handleDelete = (val, loc, srno, lineno, amt, res) => {
        if (res.tfd_knockoff_srno > 0) {
            const object = {
                location: loc,
                flag: noteType,
                type: 'IB',
                srno: srno,
                lineno: lineno,
                amt: amt < 0 ? -1 * amt : amt,
                randomString: randomString,
                tfd_1type: res.tfd_1type,
                tfd_1line_no: res.tfd_1line_no,
                tfd_1srno: res.tfd_1srno
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'canDelete', JSON.stringify(object)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                //setBookList(resp.resarray);
                if (resp.isdeletable == "0") {
                    setMsgBox(true);
                    setMsgText("Cannot delete, amount already knocked off.");
                } else {
                    setBookList(Common.arrayRemoveItem(bookList, "uniquekey", val));
                    setCounter(counter - 1);
                    calculateTotal(bookList);
                }
            });
        } else {
            setBookList(Common.arrayRemoveItem(bookList, "uniquekey", val));
            setCounter(counter - 1);
            calculateTotal(bookList);
        }
    }

    const handleBack = () => {
        setScrMode('');
    }

    const handleView = (res) => {
        // vsrno, vtype, vdate, entity_name, toGroup, toLedgerName, date, narration, fromLocation, toLocation
        setTempLineNo(1);
        setRandomString(Common.getRandomString(15));
        const { hdr_srno, hdr_type, formatted_date, tfh_narration, from_branch, to_branch, tfh_cr_dr } = res
        // console.log(hdr_srno, hdr_type, formatted_date, entity_name, hdr_group, mvli_ledger_name, tfh_date, tfh_narration, from_branch)
        $(".loader").show();
        setLocation(from_branch);
        setToLocation(to_branch);
        setEditDate(formatted_date);
        if (radioType == 'N') {
            setRadioType('A');
        }
        setSrNo(hdr_srno);
        setNarration(tfh_narration)
        const obj = {
            srNo: hdr_srno,
            location: locationCode,
            toLocation: toLocationCode,
            type: hdr_type,
        }
        Common.callApi(Common.apiIBEntry, [sid, 'viewdata', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setBookList(resp);
            $(".loader").hide();
            setScrMode('Q');
            // setShowHeaderList(false);
            // setShowHeaderList(false);
            // setShowList(true);
            setViewDate(formatted_date);
            setViewSrno(hdr_srno);
            calculateTotal(resp);
            setNIndividual(null);
            setToLocationCode(to_branch.split(' ')[0])
            // setViewTypeCD(tfh_cr_dr);
            setNoteType(tfh_cr_dr)
        });
    }

    const handleShowList = () => {
        var msg = [], i = 0;
        if (locationValue === null || (radioType === 'S' && !srnoFrom) || (radioType === 'S' && !srnoTo) || (radioType === 'D' && !fromDate) || (radioType === 'D' && !toDate)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (locationValue === null ? " From Branch." : '');
            msg[i++] = (radioType === 'S' && !srnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !srnoTo ? " To Srno." : '');
            msg[i++] = ((radioType === 'D' && !fromDate) ? " From date." : '');
            msg[i++] = ((radioType === 'D' && !toDate) ? " To date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                date: Common.dateYMD(filterDate),
                type: 'IB',
                location: locationCode,
                radioType: radioType,
                fromSrno: srnoFrom,
                toSrno: srnoTo,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                flag: noteType
            }
            $(".loader").show();
            Common.callApi(Common.apiIBEntry, [sid, 'showIBEntry', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                setHeaderList(resp);
                // setShowHeaderList(true);
            });
        }
    }

    const calculateTotal = (list) => {
        let totalDebt = 0;
        let totalCred = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i].tfd_flag == 'D') {
                totalDebt = totalDebt + list[i].tfd_amount * 1;
            } else {
                totalCred += list[i].tfd_amount < 0 ? -1 * list[i].tfd_amount : list[i].tfd_amount * 1;
            }
        }
        setTotalDebit(totalDebt);
        setTotalCredit(totalCred);
        let totalDiff = totalDebt - totalCred;
        setTotalDifference(totalDiff.toFixed(2));
        if (totalDiff < 0) {
            //setFlag('D');
            setAmount(-1 * totalDiff);
        } else if (totalDiff == 0) {
            setAmount("");
        }
        else {
            //setFlag('C');
            setAmount(totalDiff);
        }
    }

    const handleChequeNum = value => {
        setChequeValue(value);
        const cheque = value.id.split('^');
        setChequeNum(cheque[4]);
        setChequeValueNum(cheque[4]);
        setChequeSrno(cheque[1]);
        setChequeLine(cheque[2]);
        setChequeLocation(cheque[3]);
        //setChequeDate(cheque[5]);
        setChequeDate(new Date());
    }

    const handleReset = () => {
        setNIndividual(null);
    }

    const newIndividual = () => {
        setShowIndividualForm(true);
    }

    const handleNewIndiviualChange = (value) => {
        setNIndividual(value);
        if (nCorporate == null) {
            setNState({ value: faStateValue, label: faStateName });
        }
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with Red Flags individual." + master + " " + dataid);
            setMsgBox(true);
            setNIndividual(null);
            return;
        }
        if (individualsrno > 0) {
            Common.callApi(Common.apiBookEntry, [sid, "individual", individualsrno], result => {
                let resp = JSON.parse(result);
                setNIndividual(resp);
            });
        }
    }

    const handleCheckboxChange = () => {
        setChecked(!isChecked);
    };

    const btnEditRequest = () => {
        // console.log()04/02/2025
        let currDate = new Date();
        let dateDiff = "9999";
        //let dateDiff = Common.dateDifference(new Date(editDate.split('/').reverse().join('-')), new Date())//0 means todays transaction, 1 means yesterday transaction.
        const obj = {
            srno: viewSrno,
            type: 'IB',
            pageright: 'INTER_BRANCH_ENTRY',
            location: locationCode,

        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == dateDiff || resp.msg == "unlock") {// editDateLimit is 1.
                setScrMode('E');
            } else {
                setShowEditRequest(true);
                setLogObject({ trantype: 'IB', trannumber: viewSrno, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        });
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setActivityLogObject({ trantype: 'IB', trannumber: srNo, trancategory: "T", location: locationCode });
    }

    const btnSaveModal = () => {
        if (scrMode === 'E' && acRemark === '') {
            setShowModal(false);
            setMsgText('Please fill Activity Remark!');
            setMsgBox(true);
        } else {
            handleSave();
            setShowModal(false);
        }
    }
    // console.log('scrMode', scrMode);

    const handleCancelBill = () => {
        setMsgTextYNBillDelete("Are you sure.");
        setMsgBoxYNBillDelete(true);
    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'IB',
            location: locationCode,
            srno: srNo,
            productList: [],
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                handleShowList();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    // IB Entry print ==============================================
    const handleDownload = (printFlag) => {
        $(".loader").show();
        const obj = {
            srno: srNo,
            faType: 'IB',
            location: locationCode,
            printFlag: printFlag,
            type: 'IB',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }

    return (
        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ nIndivual: nIndividual, scrIndividual: 'A' }} value="FABOOK" hideIndividualProfile={hideIndividualProfile} />
                    : <>  <LoginHeader />
                        <Menu />

                        <Container fluid>
                            <Row>
                                <Col>
                                    <h2>Inter Branch Entry <span style={{ color: 'white' }}>{counter}</span></h2>
                                </Col>
                            </Row>&nbsp;

                            {
                                scrMode == '' ?
                                    <>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From Branch<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={locationValue}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleChange(e)}
                                                        isDisabled={branchDisable === "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Label>Note Type<span className="colorThemeRed">*</span></Form.Label><br />
                                                <select class="form-select" aria-label="Default select example" value={noteType}
                                                    onChange={(e) => handleNoteType(e)} >
                                                    <option value="D">Debit</option>
                                                    <option value="C">Credit</option>
                                                </select>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To Branch<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={toLocationValue}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleLocationChange(e)}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Row style={{ marginTop: "30px" }}>
                                                        {
                                                            noteType == 'D' &&
                                                            <Col>
                                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" selected />
                                                            </Col>
                                                        }
                                                        <Col>
                                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                                        </Col>
                                                        <Col>
                                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>&nbsp;
                                        <Row>
                                            {
                                                radioType === "N" ?
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                            <DatePicker className="form-control"
                                                                selected={filterDate}
                                                                onChange={(date) => setFilterDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                placeholder="dd/mm/yyyy"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    : radioType === "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control value={srnoFrom}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoFrom)}
                                                                        placeholder='From Srno'
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control value={srnoTo}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setSrnoTo)}
                                                                        placeholder='To Srno'

                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : radioType === "D" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={fromDate}
                                                                            onChange={(date) => setFromDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={toDate}
                                                                            onChange={(date) => setToDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            : null
                                            }
                                        </Row>&nbsp;
                                        <Row>
                                            <Col>
                                                {radioType == 'N' ?
                                                    <Button variant='outline-success' className='buttonStyle' size='sm'
                                                        onClick={handleAddNew}
                                                    >Add New</Button>
                                                    : <Button variant='outline-primary' className='buttonStyle' size='sm'
                                                        onClick={handleShowList}
                                                    >List</Button>
                                                }
                                            </Col>
                                        </Row>&nbsp;
                                        {

                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover>
                                                        <thead>
                                                            <tr>
                                                                {userRight.add === "1" ? <th></th> : null}
                                                                <th>Srno.</th>
                                                                <th>Type</th>
                                                                <th>Date</th>
                                                                <th>Total Debit</th>
                                                                <th>Total Credit</th>
                                                                <th>From Branch</th>
                                                                <th>To Branch</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {headerList.map((res) =>
                                                                <tr key={res.tfd_line_no}>
                                                                    {userRight.query === "1" ?
                                                                        <td className="textCenter" >
                                                                            {
                                                                                <span className="handCursor"
                                                                                    onClick={() => handleView(res)}
                                                                                >
                                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                                </span>
                                                                            }
                                                                        </td>
                                                                        : null
                                                                    }
                                                                    <td>{res.hdr_srno}</td>
                                                                    <td>{res.hdr_type}</td>
                                                                    <td>{res.formatted_date}</td>
                                                                    <td>{res.tfh_total_debit}</td>
                                                                    <td>{res.tfh_total_credit}</td>
                                                                    <td>{res.from_branch}</td>
                                                                    <td>{res.to_branch}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        }
                                    </> :
                                    <>
                                        <Row>
                                            <Col >
                                                {scrMode == 'A' || scrMode == 'E' ?
                                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleCancel} >Cancel</Button>
                                                    : <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>
                                                }&nbsp;
                                                {
                                                    (userRight.edit === "1" && scrMode === 'Q' && noteType === 'D') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>&nbsp;

                                                        {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                     handleDownload()}>Print</Button>&nbsp;
                                                 <Button variant="outline-success" className='buttonStyle' size="sm"
                                                     onClick={() => handlePrintAdvance()}>Advance</Button> */}
                                                    </> : null
                                                }
                                                {
                                                    (scrMode === 'Q' && noteType === 'D') ? <>
                                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                            handleDownload("P")}>Print</Button>
                                                    </> : null
                                                }
                                                {
                                                    (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSave} >Save</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    (userRight.query === "1" && (scrMode === 'E' || scrMode === 'Q')) ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>
                                                    </> : null
                                                }
                                                {/* {
                                                    (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                } */}
                                            </Col>
                                        </Row>&nbsp;
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Label>Serial Number : {viewSrno}</Form.Label>
                                            </Col>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Type : IB</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-6 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From Branch : {location}</Form.Label>
                                                </Form.Group>
                                            </Col>

                                            {/* <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To Branch : {toLocation}</Form.Label>
                                                </Form.Group>
                                            </Col> */}
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    {
                                                        scrMode == 'A' ?
                                                            <Form.Label>Date : {Common.dateDMY(filterDate)} </Form.Label> :
                                                            <Form.Label>Date : {viewDate} </Form.Label>
                                                    }
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Note Type : {noteType == 'D' ? 'Debit' : 'Credit'}</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-6 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To : {toLocation} </Form.Label>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        &nbsp;
                                        {scrMode == 'E' || scrMode == 'A' ?
                                            <>
                                                <Row>
                                                    <Col className='col-md-9 col-12'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={ledgerValue}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerAllowedWithGroupPicklist(search, locationCode)}
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleLedgerValue}
                                                                formatOptionLabel={Picklist.accountFormatOptionLabel}
                                                                components={{ Menu: Picklist.accountMenu }}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Amount<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                value={amount}
                                                                maxLength={Common.maximumLength}
                                                                onChange={(e) => Common.validateDecValue(e.target.value, setAmount)}
                                                                placeholder="Amount"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-12'>
                                                        <Form.Group>
                                                            <Form.Label>Knockoff</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={knockoffValue}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchKnockoffPicklist(search, locationCode, `${(flag === 'C' ? 'D' : 'C')}^${grpCode}^${accCode}^${Common.dateYMD(filterDate)}^${randomString}`)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleKnockoffValue}
                                                                formatOptionLabel={Picklist.knockOffFormatOptionLabel}
                                                                components={{ Menu: Picklist.knockkOffMenu }}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>&nbsp;
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Button variant="outline-primary" onClick={handleKnockoffSelective}>
                                                            Selective Knockoff
                                                        </Button>
                                                    </Col></Row>&nbsp;
                                                <Modal show={show} onHide={handleClose} size='xl'>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Selective Knockoff</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Row>
                                                            <Col className='col-md-3 '>
                                                                <Form.Label>Search</Form.Label>
                                                                <Form.Control
                                                                    value={srch}
                                                                    maxLength={500}
                                                                    placeholder="Search"
                                                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setSrch)}
                                                                    onBlur={handleKnockoffSelective}
                                                                />
                                                            </Col>&nbsp;
                                                            <Col className='col-md-3 '>
                                                                <Form.Label>Limit</Form.Label>
                                                                <Form.Select value={limit} onChange={(e) => setLimit(e.target.value)} required>
                                                                    <option value="100">100</option>
                                                                    <option value="50">50</option>
                                                                    <option value="20">20</option>
                                                                    <option value="15">15</option>
                                                                    <option value="10">10</option>
                                                                </Form.Select>
                                                            </Col>&nbsp;

                                                            <Col className='col-md-5 d-flex justify-content-evenly align-items-center'>
                                                                <Button variant="outline-primary" onClick={handleKnockoffSelective}>
                                                                    Search
                                                                </Button>
                                                                &nbsp;
                                                                <Button variant="primary" onClick={handleAddKnockoff}>
                                                                    Add
                                                                </Button>
                                                                &nbsp;
                                                                <Button variant="primary" onClick={() => handleAddKnockoffMultiple()}>
                                                                    Add Multiple
                                                                </Button>
                                                                &nbsp;
                                                                <Button variant="secondary" onClick={handleClose}>
                                                                    Close
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Table striped bordered hover>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                <td> <Form.Check
                                                                                    type="checkbox"
                                                                                    // checked={res.ischecked == '1'}
                                                                                    name="ischecked"
                                                                                    onChange={(e) => selectiveKnockoffCHeckHandler(e)} />
                                                                                </td>
                                                                            </th>
                                                                            <th>Pending</th>
                                                                            <th>Type</th>
                                                                            <th>Date</th>
                                                                            <th>Total Amount</th>
                                                                            <th>Adjusted Amount</th>
                                                                            <th>Individual</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {knockoffData.map((res, index) =>
                                                                            <tr key={index}>
                                                                                <td> <Form.Check
                                                                                    type="checkbox"
                                                                                    checked={res.ischecked == '1'}
                                                                                    name="ischecked"
                                                                                    onChange={(e) => updateKnockoffFields(index, e, "ischecked")} />
                                                                                </td>
                                                                                <td> <Form.Control value={res.tfd_amount} name='tfd_amount'
                                                                                    onChange={(e) => updateKnockoffFields(index, e, "tfd_amount")} />
                                                                                </td>
                                                                                <td>{res.tfd_knockoff_type+" "+ res.tfd_knockoff_srno}</td>
                                                                                <td>{res.tfd_date}</td>
                                                                                <td>{res.total_amount}</td>
                                                                                <td>{res.knockoff_amount}</td>
                                                                                <td>{res.individual_full_name}&nbsp;{res.tfd_reftype}&nbsp;{res.tfd_refnumber}</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                        </Row>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleClose}>
                                                            Close
                                                        </Button>
                                                        <Button variant="primary" onClick={handleAddKnockoff}>
                                                            Add
                                                        </Button>
                                                        <Button variant="primary" onClick={() => handleAddKnockoffMultiple()}>
                                                            Add Multiple
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                                <Row>
                                                    {accountType == 'BANK' &&
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                                                                <Form.Select value={transferCheque} onChange={(e) => setTransferCheque(e.target.value)} required>
                                                                    <option value="T">Transfer/Ref No.</option>
                                                                    <option value="C">Cheque</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    }
                                                    {
                                                        accountType == "CHEQUE" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control
                                                                            value={chequeNum}
                                                                            maxLength={Common.maximumLength}
                                                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                            placeholder={accountType == 'CHEQUE' || accountType == 'BANK' && transferCheque == 'C' ? 'Cheque Number' : 'Reference Number'}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Bank Name<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control
                                                                            value={bankName}
                                                                            maxLength={100}
                                                                            onChange={(e) => Common.validateAlpValue(e.target.value, setBankName)}
                                                                            placeholder="Bank Name"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque Date<span className="text-danger">*</span></Form.Label><br />
                                                                        <DatePicker className="form-control"
                                                                            selected={chequeDate}
                                                                            onChange={(date) => setChequeDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            placeholder="dd/mm/yyyy"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </> : null
                                                    }
                                                    {
                                                        accountType == "BANK" ?
                                                            <> <Col className='col-md-3 col-6'>
                                                                <Form.Group>

                                                                    {
                                                                        noteType == 'C' && transferCheque == 'T' &&
                                                                        <>
                                                                            <Form.Label>Reference Number<span className="text-danger">*</span></Form.Label>
                                                                            <Form.Control
                                                                                value={chequeNum}
                                                                                maxLength={255}
                                                                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                                placeholder="Reference Number"
                                                                            />
                                                                        </>
                                                                    }
                                                                    {
                                                                        noteType == 'C' && transferCheque == 'C' &&
                                                                        <>
                                                                            <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                            <AsyncSelect
                                                                                cacheOptions={false}
                                                                                defaultOptions={false}
                                                                                value={chequeValue}
                                                                                getOptionLabel={e => e.label + ' '}
                                                                                getOptionValue={e => e.id}
                                                                                loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, grpCode, accCode, locationCode)}
                                                                                onInputChange={Picklist.handleInputChange}
                                                                                onChange={(e) => handleChequeNum(e)}
                                                                            >
                                                                            </AsyncSelect>
                                                                        </>
                                                                    }
                                                                    {
                                                                        noteType == 'D' && transferCheque == 'T' &&
                                                                        <>
                                                                            <Form.Label>Reference Number<span className="text-danger">*</span></Form.Label>
                                                                            <Form.Control
                                                                                value={chequeNum}
                                                                                maxLength={100}
                                                                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setChequeNum)}
                                                                                placeholder="Reference Number"
                                                                            />
                                                                        </>
                                                                    }&nbsp;
                                                                    {
                                                                        noteType == 'D' && transferCheque == 'C' &&
                                                                        <>
                                                                            <Form.Label>Cheque Number<span className="text-danger">*</span></Form.Label>
                                                                            <AsyncSelect
                                                                                cacheOptions={false}
                                                                                defaultOptions={false}
                                                                                value={chequeValue}
                                                                                getOptionLabel={e => e.label + ' '}
                                                                                getOptionValue={e => e.id}
                                                                                loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, grpCode, accCode, locationCode)}
                                                                                onInputChange={Picklist.handleInputChange}
                                                                                onChange={(e) => handleChequeNum(e)}
                                                                            >
                                                                            </AsyncSelect>
                                                                        </>
                                                                    }&nbsp;
                                                                </Form.Group>
                                                            </Col>
                                                                {noteType == 'D' && transferCheque == 'C' &&
                                                                    <Col className='col-md-3 col-6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Bank Name<span className="text-danger">*</span></Form.Label>
                                                                            <Form.Control
                                                                                value={bankName}
                                                                                maxLength={100}
                                                                                onChange={(e) => Common.validateAlpValue(e.target.value, setBankName)}
                                                                                placeholder="Bank Name"
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                }&nbsp;
                                                            </>
                                                            : null
                                                    }
                                                </Row>
                                                <Row>
                                                    {accountType == 'WALKIN' &&
                                                        <Col className='col-md-9'>
                                                            <Form.Group>
                                                                <Form.Label>Individual Profile
                                                                    {
                                                                        scrMode === "A" &&
                                                                        <span>  <span className='tranNewFormText'
                                                                            onClick={() => newIndividual()}
                                                                        >Not in list? Create New </span>
                                                                            <span>
                                                                                <Badge bg="secondary" onClick={handleReset}>Reset</Badge>
                                                                            </span>
                                                                        </span>
                                                                    }
                                                                </Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={nIndividual}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={Picklist.fetchIndividualMainPicklist}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={handleNewIndiviualChange}
                                                                    isDisabled={scrMode === "Q"}
                                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                                    components={{ Menu: Picklist.menu }}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>
                                                    }
                                                </Row>&nbsp;
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleAdd} >Add</Button>
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Show Additional Details"
                                                            checked={isChecked}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </Col>
                                                </Row>&nbsp;
                                            </> : null
                                        }

                                        <>
                                            <Row>
                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            {
                                                                isChecked ?
                                                                    <td
                                                                        colSpan={10}
                                                                    ></td> : <td
                                                                        colSpan={6}
                                                                    ></td>
                                                            }
                                                            <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Debit:</b> <span>{totalDebit}</span></td>
                                                            <td style={{ textAlign: 'right' }} colSpan={1}><b>Total Credit:</b> <span>{totalCredit}</span></td>
                                                        </tr>
                                                        <tr>
                                                            {userRight.delete === "1" ? <th></th> : null}
                                                            <th>Group</th>
                                                            <th>Account</th>
                                                            <th>Account Name</th>
                                                            <th>Individual</th>
                                                            <th>Knockoff</th>
                                                            <th style={{ textAlign: 'right' }}>Debit</th>
                                                            <th style={{ textAlign: 'right' }}>Credit</th>
                                                            {isChecked && <>
                                                                <th>Cheque Number</th>
                                                                <th>Cheque Date</th>
                                                                <th>Cheque Bank Name</th>
                                                            </>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bookList.filter(res => res.tfd_reftype !== "GB").map((res, index) =>
                                                            <tr key={res.tfd_line_no}>
                                                                {(userRight.query === "1") ?
                                                                    <td className="textCenter" >
                                                                        {
                                                                            (scrMode !== "Q" && res.delny == "Y" && res.tfd_flag != 'D') ?
                                                                                <span className="handCursor colorThemeBlue"
                                                                                    onClick={() => handleDelete(res.uniquekey, res.tfd_location, res.tfd_srno, res.tfd_line_no, res.tfd_amount, res)}>
                                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                                </span>
                                                                                : null
                                                                        }
                                                                    </td>
                                                                    : null
                                                                }
                                                                <td>{res.tfd_group}</td>
                                                                <td>{res.tfd_account}</td>
                                                                <td>{res.mvli_ledger_name}</td>
                                                                <td>{res.tfd_individual}</td>
                                                                <td>{res.tfd_knockoff_srno == "null" || res.tfd_knockoff_srno == "0" || res.tfd_knockoff_srno == null ? null : res.tfd_knockoff_type + ' ' + res.tfd_knockoff_srno}</td>
                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag === 'D' ? Math.abs(res.tfd_amount).toFixed(2) : ''}</td>
                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag === 'C' ? (res.tfd_amount < 0 ? -1 * Math.abs(res.tfd_amount).toFixed(2) : Math.abs(res.tfd_amount).toFixed(2)) : ''}</td>
                                                                {isChecked && <>
                                                                    <td>{res.tfd_cheque_no}</td>
                                                                    <td>{res.cheque_date}</td>
                                                                    <td>{res.tfd_cheque_bank_name}</td>
                                                                </>}

                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    <br />
                                                    <tbody>
                                                        {bookList.filter(res => res.tfd_reftype === "GB").map((res, index) =>
                                                            <tr key={res.tfd_line_no}>
                                                                {(userRight.delete === "1") ?
                                                                    <td className="textCenter" >
                                                                        {
                                                                            (scrMode !== "Q" && res.delny == "Y" && res.tfd_flag != 'D') ?
                                                                                <span className="handCursor colorThemeBlue"
                                                                                    onClick={() => handleDelete(res.uniquekey, res.tfd_location, res.tfd_srno, res.tfd_line_no, res.tfd_amount)}>
                                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                                </span>
                                                                                : null
                                                                        }
                                                                    </td>
                                                                    : null
                                                                }
                                                                <td>{res.tfd_group}</td>
                                                                <td>{res.tfd_account}</td>
                                                                <td>{res.mvli_ledger_name}</td>
                                                                <td>{res.tfd_individual}</td>
                                                                <td>{res.tfd_knockoff_srno == "null" || res.tfd_knockoff_srno == "0" || res.tfd_knockoff_srno == null ? null : res.tfd_knockoff_type + ' ' + res.tfd_knockoff_srno}</td>
                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag === 'D' ? res.tfd_amount : ''}</td>
                                                                <td style={{ textAlign: 'right' }}>{res.tfd_flag === 'C' ? (res.tfd_amount < 0 ? -1 * res.tfd_amount : res.tfd_amount) : ''}</td>
                                                                {isChecked && <>
                                                                    <td>{res.tfd_cheque_no}</td>
                                                                    <td>{res.cheque_date}</td>
                                                                    <td>{res.tfd_cheque_bank_name}</td>
                                                                </>}

                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </Row>
                                            <Row>
                                                {/* {viewSrno == 0 && */}
                                                <FloatingLabel controlId="floatingTextarea2" label="Narration">
                                                    <Form.Control
                                                        value={narration}
                                                        maxLength={999}
                                                        as="textarea"
                                                        placeholder="Leave a comment here"
                                                        style={{ height: '100px' }}
                                                        onChange={(e) => setNarration(e.target.value)}
                                                        disabled={scrMode === 'Q'}
                                                    />
                                                </FloatingLabel>
                                                {/* } */}
                                            </Row>
                                        </>
                                        <hr />
                                        <Row>
                                            <Col >
                                                {scrMode == 'A' || scrMode == 'E' ?
                                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleCancel} >Cancel</Button>
                                                    : <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>
                                                }&nbsp;
                                                {
                                                    (userRight.edit === "1" && scrMode === 'Q' && noteType === 'D') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnEditRequest()}>Edit</Button>&nbsp;

                                                        {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                     handleDownload()}>Print</Button>&nbsp;
                                                 <Button variant="outline-success" className='buttonStyle' size="sm"
                                                     onClick={() => handlePrintAdvance()}>Advance</Button> */}
                                                    </> : null
                                                }
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() =>
                                                    handleDownload("P")}>Print</Button>
                                                {
                                                    (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleSave} >Save</Button> : null
                                                }
                                                &nbsp;
                                                {
                                                    (userRight.query === "1" && (scrMode === 'E' || scrMode === 'Q')) ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>
                                                    </> : null
                                                }
                                                {/* {
                                                    (scrMode === "Q" && userCancelBillRight.query === "1") &&
                                                    <>
                                                        &nbsp;
                                                        <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                                    </>
                                                } */}
                                            </Col>
                                        </Row>&nbsp;
                                    </>
                            }
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </Container>
                    </>
            }
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <ActivityLog logObject={activityLogObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Tran_data_unlock_request logObject={logObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        {
                            scrMode === 'E' ?
                                <>
                                    <Form.Group>
                                        <Form.Label>Reason<span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Reason" maxLength={499}
                                            value={acRemark}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setAcRemark)}
                                            autoComplete="off"
                                            required />
                                    </Form.Group>
                                </> :
                                null
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => btnSaveModal()}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
}

export default Inter_branch_entry
